<template>
    <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
        <div class="container-fluid">

            <!--Toggler-->
            <navbar-toggle-button @click.native="showSidebar">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>
            <router-link class="navbar-brand" to="/">
                <img :src="logo" class="navbar-brand-img" alt="...">
            </router-link>

            <slot name="mobile-right">
                <ul class="nav align-items-center d-md-none">
                    <base-dropdown class="nav-item" position="right">
                        <a slot="title" class="nav-link" href="#" role="button">
                            <div class="media align-items-center">
                              <span class="avatar-sm rounded-circle">
                                <!--<img alt="Image placeholder" src="img/theme/team-1-800x800.jpg">-->
                              </span>
                            </div>
                        </a>

                    </base-dropdown>
                </ul>
            </slot>
            <slot></slot>
            <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">

                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <img :src="logo">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
                        </div>
                    </div>
                </div>

                <ul class="navbar-nav">
                    <slot name="links">
                    </slot>
                </ul>
                <!--Divider-->
                <hr class="my-3">
                <!--Heading-->
                <ul class="navbar-nav mb-md-3">
                    <li class="nav-item">
                        <a class="nav-link" target="_blank" href="#" @click.prevent="logout">
                            <i class="ni ni-button-power"></i> Desconectar
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
<script>
    import NavbarToggleButton from '@/components/NavbarToggleButton'

    export default {
        name: 'sidebar',
        components: {
            NavbarToggleButton
        },
        props: {
            logo: {
                type: String,
                default: 'img/logo.png',
                description: 'Sidebar app logo'
            },
            autoClose: {
                type: Boolean,
                default: true,
                description:
                    'Whether sidebar should autoclose on mobile when clicking an item'
            }
        },
        provide() {
            return {
                autoClose: this.autoClose
            };
        },
        methods: {
            closeSidebar() {
                this.$sidebar.displaySidebar(false)
            },
            showSidebar() {
                this.$sidebar.displaySidebar(true)
            },
            logout() {
                this.$store.dispatch("setJWT", "");
                this.$store.dispatch("setUser", "");
                this.$store.dispatch("setType", "");
                this.$store.dispatch("setSede", "");

                this.$cookie.delete('jwt');
                this.$cookie.delete('user');
                this.$cookie.delete('type');
                this.$cookie.delete('sede');

                this.$router.push("/login");
            }
        },
        beforeDestroy() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.showSidebar = false;
            }
        }
    };
</script>
